export enum DeviceType {
	Akamai = 'Akamai',
	AkamaiLive = 'AkamaiLive',
	Custom = 'Custom',
	Dme = 'Dme',
	Encoder = 'Encoder',
	LdapConnector = 'LdapConnector',
	OmniCache = 'OmniCache'
}
